import { IFilter } from 'server/models/Filter/types';
import { clientApi } from 'api';

export const addProductFilter = (isServer = false) => async (value: IFilter) => {
  const response = await clientApi.post<IFilter>(`/filter-products/`, value);

  return response;
};
